import { Link } from 'react-router-dom'

interface SectionHeaderProps {
  title: string
  linkTo?: string
  linkLabel?: string
}

export function SectionHeader({ title, linkTo, linkLabel = 'View All' }: SectionHeaderProps) {
  return (
    <div className="section-header">
      <h2 className="text-lg font-bold text-slate-100">{title}</h2>
      {linkTo && (
        <Link to={linkTo} className="text-sm font-medium text-accent hover:text-accent-light transition-colors">
          {linkLabel} &rarr;
        </Link>
      )}
    </div>
  )
}
